import { render, staticRenderFns } from "./inventoryView.vue?vue&type=template&id=93bf2a24&"
import script from "./inventoryView.vue?vue&type=script&lang=js&"
export * from "./inventoryView.vue?vue&type=script&lang=js&"
import style0 from "./inventoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports